// ── Card и SectionHeader — карточка-блок и заголовок раздела ─────────────────
// Card: плоская поверхность с тонкой рамкой (стиль «вариант A»). Если задан
// title — сверху строка заголовка с действиями справа.
// SectionHeader: крупный заголовок раздела, подпись и кнопки. На узком экране
// кнопки переносятся под заголовок, а длинный заголовок — на новую строку
// (не обрезается).

import { SANS, themeKit } from '../themes';
import { panelSurface } from './surface';
import { usePalette, usePhone } from './theme';

export function Card({ title, actions, children, padding, flush = false, style, C: Cp, as: Tag = 'section', ...rest }) {
  const C = usePalette(Cp);
  const phone = usePhone();
  const pad = padding ?? (phone ? 14 : 16);
  return (
    <Tag data-panel="" style={{ ...panelSurface(C), borderRadius: 12, minWidth: 0, boxSizing: 'border-box',
      // поверхность из темы (surface.js): в «Аркаде» — стекло на столе с «ребром» снизу
      fontFamily: SANS, color: C.text, overflow: flush ? 'hidden' : undefined, ...style }} {...rest}>
      {(title || actions) && (
        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8, padding: `${pad - 2}px ${pad}px`,
          borderBottom: flush ? `1px solid ${C.borderSoft}` : 'none' }}>
          {title && <h3 style={{ margin: 0, flex: '1 1 160px', minWidth: 0, fontSize: 15, fontWeight: 600, color: C.text, overflowWrap: 'break-word' }}>{title}</h3>}
          {actions && <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginLeft: 'auto' }}>{actions}</div>}
        </div>
      )}
      <div style={{ padding: flush ? 0 : (title || actions) ? `0 ${pad}px ${pad}px` : pad }}>{children}</div>
    </Tag>
  );
}

export function SectionHeader({ title, subtitle, actions, level = 1, style, C: Cp }) {
  const C = usePalette(Cp);
  const phone = usePhone();
  const H = level === 1 ? 'h1' : 'h2';
  // «Колода» (layout hand): действия сразу за названием, а не у дальнего края.
  const near = themeKit(C).layout === 'hand';
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap', gap: near ? '8px 24px' : '8px 12px', marginBottom: phone ? 12 : 16, minWidth: 0, fontFamily: SANS, ...style }}>
      <div style={{ flex: near ? '0 1 auto' : '1 1 220px', minWidth: 0 }}>
        <H style={{ margin: 0, fontSize: level === 1 ? (phone ? 22 : 26) : 18, fontWeight: 600, color: C.text, letterSpacing: '-0.01em',
          lineHeight: 1.2, overflowWrap: 'break-word' }}>{title}</H>
        {subtitle && <div style={{ marginTop: 4, fontSize: 14, color: C.mid, lineHeight: 1.4, overflowWrap: 'break-word' }}>{subtitle}</div>}
      </div>
      {actions && <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>{actions}</div>}
    </div>
  );
}
